export default __webpack_public_path__ + "static/media/background.f8c100d8.jpg";